"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = exports.rangeFunctional = exports.rangeGenerator = void 0;
function* rangeGenerator(start, end, increment) {
    for (let i = start; i <= end; i += increment)
        yield i;
}
exports.rangeGenerator = rangeGenerator;
const rangeFunctional = (start, end, increment) => {
    const ranger = rangeGenerator(start, end, increment);
    return () => ranger.next().value;
};
exports.rangeFunctional = rangeFunctional;
const range = (start = 0, end = Infinity, increment = 1) => {
    const ranger = (0, exports.rangeFunctional)(start, end, increment);
    const generationHandler = {
        get: function (arr, prop) {
            if (typeof prop !== "string")
                return undefined;
            const nprop = Number(prop);
            while (nprop >= arr.length) {
                arr.push(ranger());
            }
            return arr[nprop];
        },
    };
    const p = new Proxy([], generationHandler);
    return p;
};
exports.range = range;
//# sourceMappingURL=range.js.map